<template>
    <div>
        <i class="fa fa-user-md flow-blue-color w3-xlarge w3-margin-right"></i>
        <content-header v-bind:title="$t('addNewPhysician')"></content-header>
        <div class="w3-margin-top w3-margin-bottom">
            <div class="w3-container zero-bottom w-90pc w3-show-inline-block flow-form-inline-input">
                <p class="flow-padding-bottom zero-top w-100pc">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("name") }}</label>
                    <input class="w3-input w3-border w3-round-medium" type="text"
                           v-model="newPhysician.name"
                           v-bind:placeholder="$t('name')"/>
                    <span class="w3-text-red">{{ npNameError }}</span>
                </p>
            </div>

            <div class="w3-container zero-bottom w-90pc w3-show-inline-block flow-form-inline-input">
                <p class="flow-padding-bottom zero-top w-100pc">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("agendaSystemIds") }}</label>
                    <input class="w3-input w3-border w3-round-medium" type="text"
                           v-model="newPhysician.agsId"
                           v-bind:placeholder="$t('agendaSystemIds')"/>
                    <span class="w3-text-red">{{ npAgsError }}</span>
                </p>
            </div>

            <div class="w3-container zero-bottom zero-top">
                <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top w3-margin-right" @click.prevent="addNewPhysician">
                    <i class="fa fa-save flow-green-active-color">
                        <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                    </i>
                </button>

                <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top" @click.prevent="onClose">
                    <i class="fa fa-arrow-left w3-text-red">
                        <span><b class="flow-margin-left">{{$t('back')}}</b></span>
                    </i>
                </button>
            </div>

        </div>
    </div>



</template>

<script>
    import ContentHeader from "../common/ContentHeader";
    import {EventBus} from "../../main";
    import Vue from 'vue';

    const frc = Vue.prototype.$frc;

    export default {
        name: "NewPhysician",
        components: {ContentHeader},
        props: ['onClose'],
        data() {
            return {
                newPhysician: {},
                npNameError: undefined,
                npAgsError: undefined
            }
        },
        methods: {
            addNewPhysician() {
                var app = this;
                this.npNameError = undefined; this.npAgsError = undefined;

                if (!this.newPhysician.name || !this.newPhysician.name.trim()) {
                    this.npNameError = this.$t('INVALID_NAME');
                }

                if (!this.newPhysician.agsId || !this.newPhysician.agsId.trim()) {
                    this.npAgsError = this.$t("INVALID_REFERENCES");
                }

                if (this.npNameError || this.npAgsError) return;

                frc.addNewPhysician(Vue.prototype.$currentWard.id, this.newPhysician.name, this.newPhysician.agsId).then(function (res) {
                    Vue.notifySuccess({
                        title: app.$t("success"),
                        message: app.newPhysician.name + " is added"
                    });
                    EventBus.$emit("onNewPhysicianAdded");
                    app.onClose();
                }).catch(function (ex) {
                    console.error(ex);
                    if (ex.restCodes && ex.restCodes.length > 0) {
                        for (var i in ex.restCodes) {
                            var code = ex.restCodes[i];
                            console.log(code);
                            if (code === "AGENDA_SYSTEM_REFERENCES_EXISTS" || code === "INVALID_REFERENCES") {
                                app.npAgsError = app.$t(code);
                            }
                            if (code === "INVALID_SCREEN_NAME") {
                                app.npNameError = app.$t('INVALID_NAME');
                            }
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>